import { TeamTemplateSize } from "state/entities/teamTemplateSizes/teamTemplateSizesActions";
import SmoothPencilIconComponent from "views/components/icons/SmoothPencilIcon";
import TrashCanIconComponent from "views/components/icons/TrashCanIcon";
import { fromPixels } from "./modals/teamTemplateSizeFormUtils";
import style from "./style.module.css";

const SmoothPencilIcon = SmoothPencilIconComponent as any;
const TrashCanIcon = TrashCanIconComponent as any;

interface BrandKitSizesRowProps {
  size: TeamTemplateSize;
  isBrandManager: boolean;
  onEdit: (size: TeamTemplateSize) => void;
  onDelete: (size: TeamTemplateSize) => void;
}

const BrandKitSizesRow = ({
  size,
  isBrandManager,
  onEdit,
  onDelete
}: BrandKitSizesRowProps) => {
  const displayWidth = fromPixels(size.width, size.measurementUnits);
  const displayHeight = fromPixels(size.height, size.measurementUnits);
  const dimensions = `${displayWidth} × ${displayHeight} ${size.measurementUnits}`;

  return (
    <div
      className={`${style.sizeRow} ${size.active ? "" : style.sizeRowInactive}`}
      data-testid="brandKitSizesRow"
      data-active={size.active}
    >
      <div className={style.sizeRowLeft}>
        <div className={style.sizeRowName}>{size.name}</div>
        <div className={style.sizeRowMeta}>
          <span>{dimensions}</span>
          <div className={style.sizeRowBadges}>
            <span className={style.badge}>{size.templateType}</span>
            {size.doubleSided && (
              <span
                className={`${style.badge} ${style.badgeDoubleSided}`}
                data-testid="doubleSidedBadge"
              >
                Double-sided
              </span>
            )}
            {!size.active && (
              <span
                className={`${style.badge} ${style.badgeInactive}`}
                data-testid="inactiveBadge"
              >
                Inactive
              </span>
            )}
          </div>
        </div>
      </div>

      {isBrandManager && (
        <div className={style.rowActions}>
          <button
            className={style.rowActionButton}
            onClick={() => onEdit(size)}
            data-testid="editSizeButton"
            aria-label={`Edit ${size.name}`}
            type="button"
          >
            <SmoothPencilIcon size="20px" />
          </button>
          <button
            className={style.rowActionButton}
            onClick={() => onDelete(size)}
            data-testid="deleteSizeButton"
            aria-label={`Delete ${size.name}`}
            type="button"
          >
            <TrashCanIcon size="20px" />
          </button>
        </div>
      )}
    </div>
  );
};

export default BrandKitSizesRow;
